/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_NotesInputs */

const en_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const fr_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const de_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmerkungen`)
};

const it_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const ru_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечания`)
};

const es_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

const zh_cn2_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔记`)
};

const ja_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注記`)
};

const hi_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स`)
};

const pt_pt2_quicktools_tab_notes = /** @type {(inputs: Quicktools_Tab_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Quicktools_Tab_NotesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_notes = /** @type {((inputs?: Quicktools_Tab_NotesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_NotesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_notes(inputs)
	if (locale === "de") return de_quicktools_tab_notes(inputs)
	if (locale === "it") return it_quicktools_tab_notes(inputs)
	if (locale === "ru") return ru_quicktools_tab_notes(inputs)
	if (locale === "es") return es_quicktools_tab_notes(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_notes(inputs)
	if (locale === "ja") return ja_quicktools_tab_notes(inputs)
	if (locale === "hi") return hi_quicktools_tab_notes(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_notes(inputs)
	return en_quicktools_tab_notes(inputs)
});